import {Component, ElementRef, EventEmitter, Input, Output, Renderer2} from '@angular/core';
import {Subscription} from 'rxjs';
import {TranslocoService} from '@ngneat/transloco';

/// from https://blog.bitsrc.io/3-ways-to-debounce-http-requests-in-angular-c407eb165ada

@Component({
    selector: 'app-search-bar',
    templateUrl: './search-bar.component.html',
    styleUrls: ['./search-bar.component.scss'],
    standalone: false
})
export class SearchBarComponent {
  @Input() searchBarClass: string | undefined;
  @Input() items: any = [];
  @Input() searchPlaceholder: string = "..."

  @Output() onSearch: EventEmitter<string> = new EventEmitter();
  @Output() onSelectItem: EventEmitter<any> = new EventEmitter();


  subscriptions: Subscription[] = [];
  events: any[] = [];

  @Input() inputValue: string = "";
  @Input() showEmptyState: boolean = false;
  @Input() isLoading: boolean = false;
  @Input() isTransparent: boolean = false;
  private outsideClickListener: (() => void) | undefined;

  constructor(public translocoService: TranslocoService,
              private elementRef: ElementRef,
              private renderer: Renderer2) {
  }

  ngAfterViewInit(): void {
    this.outsideClickListener = this.renderer.listen('document', 'click', this.onClickOutside.bind(this));
  }

  private onClickOutside(event: Event): void {
    const clickedInside = this.elementRef.nativeElement.contains(event.target);
    if (!clickedInside) {
      this.closeList();
    }
  }


  ngOnDestroy(): void {
    if (this.outsideClickListener) {
      this.outsideClickListener();
    }
  }

  private closeList(): void {
    this.items = [];
    this.showEmptyState = false;
  }

  public onInput(event: Event): void {
    this.onSearch.emit((event.target as HTMLInputElement).value);
  }

  public selectItem(item: any): void {
    this.onSelectItem.emit(item);
  }
}

